var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasUser)?_c('div',{staticClass:"mr-3"},[_c('avatar',{attrs:{"user-uid":_vm.userUid,"size":"md"}}),_c('p',{staticClass:"font-10 strong text-center mb-0"},[_vm._v(" "+_vm._s(_vm.user.fullname)+" ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }